import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { message, Switch, Select, Form, Input, Space, Alert, Tooltip } from 'antd';

import { app } from '../../config';
import { LeftCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import getHeaders from '../../utils/authHeaders';
import { AddRecord } from '../../layouts/AddRecord';
import { InputField, InputMasker, SelectField } from '../../layouts/FormFields';
import useFetchProducts from '../../hooks/fetchProducts';
import useFetchPartners from '../../hooks/fetchPartner';
import { extractObjValues } from '../../utils/extractObjValues';

const AddShopPartner = () => {
  const [resetModal, setResetModal] = useState(false);
  const [show, setShow] = useState(false);
  const [apiResp, setAPIResp] = useState(false);

  const [alert, setAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [addUserResp, setAddUserResp] = useState({});
  const [uploadArr, setUploadArr] = useState([]);

  const [phoneNumber, setPhoneNumber] = useState();
  const [successMsg, setSuccessMsg] = useState('');
  const [noinvList, setNoinvList] = useState(false);
  const [addInvResp, setAddInvResp] = useState({});
  // new states:
  const [products, setProducts] = useState([]);
  const [invListData, setInvListData] = useState([]);
  const [shopPartnerId, setShopPartnerId] = useState('');
  const [affiliateParents, setaffiliateParents] = useState([]);

  let prrds;

  const fetchedProducts = useFetchProducts(setProducts);
  prrds = fetchedProducts.response ? fetchedProducts.response.data : [];
  // setProducts(prrds);
  // console.log('prrds-->', prrds);
  // console.log('initial-products--->', products);

  // console.log('fetchedProducts-->', fetchedProducts);

  const fetchedPartners = useFetchPartners();
  const partners = fetchedPartners.response ? fetchedPartners.response.data : [];
  // console.log(partners);

  let navigate = useNavigate();
  const [form] = Form.useForm();

  const [productForm] = Form.useForm();
  const [uploadObj, setUploadObj] = useState({});
  const [uploadObj1, setUploadObj1] = useState({});
  const [apiUrl, setApiUrl] = useState('');
  const [selectedProducts, setSelectedProducts] = useState([]); // Track selected product IDs
  const [isdisable, setisdisable] = useState(false);
  const uploadData = async (userDetails) => {
    console.log(userDetails);
    // setLoading(true);
    // let userId = user?.result.data.user.userId;
    // userDetails.userId = userId;
    try {
      console.log('uploadObj ', userDetails);
      // console.log('apiurl ', apiUrl);

      // return
      const res = await axios.post(`${app.URL}/api/v1/admin/shoppartner/register`, userDetails, { headers: getHeaders() });
      // setLoading(false);
      // setShow(false);
      console.log('res-->', res);

      if (res.data.result.success) {
        setAddUserResp(res.data.result.data);
        localStorage.setItem('shopPartnerId', res.data.result.data.shopPartnerId);
        message.success(res.data.result.msg);
        setisdisable(true);

        // setSuccessMsg(res.data.result.msg);
        setAlert(true);
        // setTimeout(goBack, 1000);
      } else if (!res.data.result.success) {
        // setSuccessMsg(res.data.result.msg);
      }
    } catch (err) {
      setLoading(false);
      setShow(false);
      console.log(err);
        message.error(err?.response?.data?.result?.msg ? err.response.data.result.msg:'Affiliate  doesnot added ');

      if (err) console.log(err.response.data.result.data.errors[0].message);
      else return;
    }
  };
  const getaffiliateParent = async() => {
    try {
      let resp = await axios.get(`${app.URL}/api/v1/admin/affiliateparent/getparents`, { headers: getHeaders() });
      console.log('resp here is ', resp.data.result.data);
      if (resp.status == 200) {
        setaffiliateParents(resp?.data?.result?.data);
      }
    } catch (error) {
      console.log(error)
    }
  }
  // console.log('apiurl ', apiUrl);
  useEffect(() => {
    getaffiliateParent()
  
},[])
  const onFinish = (values) => {
    console.log('values', values);
// return
    setUploadObj({
      email: values.email ? values.email : null,
      clientId: values.clientId ? values.clientId.trim() : null,
      // parentId: values.parentId ? values.parentId : null,
      parentId: values.parentId ? values.parentId : null,

      phone: values.phone ? values.phone.split('_')[0].slice(0, 12) : '',
      address: values.address ? values.address.trim() : null,
      contactName: values.contactName ? values.contactName.trim() : null,
      affiliateName: values.affiliateName ? values.affiliateName.trim() : null,
      callbackUrl: values.callBackUrl ? values.callBackUrl.trim() : null,
      isActive: true,
      // isActive: values.isActive ? values.isActive : null,
    });
    console.log('apiUrl', apiUrl);
    //  if (!apiUrl || apiUrl.length < 0) {
    //   //  setShow(false);
    //    message.error('Kindly  Select atleast one Product');
    //    return;
    //  }
    // if (!isSelect) {
    //   message.error('Kindly  Select atleast one Product');
    //   return;
    // }
    setShow(true);
  };

  const handleChange = (event) => {
    setPhoneNumber(event.target.value);
    // handle phone number input here
  };

  // function validatePhoneNumber(phoneNumber) {
  //   // Regular expression for US phone numbers with optional area code and dashes
  //   const phoneRegex = /^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
  //   // const phoneRegex = /^\+?\d+$/;

  //   // Test the phone number against the regex pattern
  //   return phoneRegex.test(phoneNumber);
  // }

  const submitData = () => {
    console.log('calling', phoneNumber, apiUrl);
    console.log('apiUrl', apiUrl);

    console.log(phoneNumber?.split('_')[0].length);

    if (phoneNumber?.split('_')[0].length < 12) {
      setShow(false);
      message.error('Mobile number should be at least 10 characters long');
      return 
    }
    // else if (!validatePhoneNumber(phoneNumber)) {
    //   message.error('Phone number should contain US state codes!');
    // }
    else {
      setShow(false);
      uploadData(uploadObj);
      // form.resetFields();
    }
  };

  const handleClose = () => setShow(false);
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  function goBack() {
    navigate('/shoppartner/view', { replace: true });
  }
  window.addEventListener('popstate', goBack);
console.log("affiliateParents", affiliateParents);
  const shopPartnerMapping = (values) => {
    console.log('values-->', values.invList);

    const { invList } = values;
    console.log('invList-->', invList);

    const shopPartnerId = localStorage.getItem('shopPartnerId');

    // Map over invList to create the required payload format
    const payload = invList.map((item) => ({
      shopPartnerId, // Use the shopPartnerId from localStorage
      productId: item.product, // Access the selected product ID
      commissionPercentage: item.commission,
      commissionPercentageClient: item.clientcommission,
    }));

    console.log('payload--->', payload);
    // return;
    // TODO: Add API integration
    try {
      axios
        .post(`${app.URL}/api/v1/admin/shoppartnermapping/create`, payload, { headers: getHeaders() })
        .then((res) => {
          console.log(res);
          console.log('api-res-add-wali--->', res.data.result.data);
          // setLoading(false);

          if (res.data.result.success) {
            setAPIResp(true); // Show new Select
            setApiUrl(res.data.result.data);
            // setdisabl
            setAlert(true);
        setisdisable(false);

            localStorage.setItem('addPartnerProducts', JSON.stringify(res.data.result.data));
            message.success('Product Added Successfully!');
          } else {
            message.warning(res.data.result.msg);
          }
        })
        .catch((err) => {
          setLoading(false);
          message.warning('Error occurred. Please try again.');
          console.log(err);
        });
    } catch (err) {
      console.error('Unexpected error:', err);
    }
  };

  const shopPartnerMappingFailed = (errorInfo) => {
    console.log('Failed:', errorInfo.values.invList);

    // Extract boxType values from the invList array
    const boxTypesToRemove = errorInfo?.values?.invList?.filter((item) => item.product !== undefined).map((item) => item.product);

    // Filter the main bocType array
    setProducts(prrds.filter((item) => !boxTypesToRemove.includes(item.productId)));
  };

  const handleRemove = (name, remove, index) => {
    console.log("handle remove")
    // Remove the selected product for the specific index
    const updatedSelectedProducts = [...selectedProducts];
    updatedSelectedProducts.splice(index, 1); // Remove the value at the specified index
    setSelectedProducts(updatedSelectedProducts); // Update state

    // Call Ant Design's remove function to remove the field
    remove(name);
  };

  const getFilteredProducts = (index) => {
    return products.filter(
      (product) =>
        !selectedProducts.includes(product.productId) || // Exclude already selected values
        selectedProducts[index] === product.productId // Include the current dropdown's selected value
    );
  };

  // Handle product change
  const handleProductChange = (value, index) => {
    // console.log('value--->', value);
    // console.log('index--->', index);

    const updatedSelectedProducts = [...selectedProducts];
    updatedSelectedProducts[index] = value; // Update the value for the specific index
    setSelectedProducts(updatedSelectedProducts); // Update state
    // setisSelect(true);
  };

  const handleNumericChange = (event) => {
    const { value } = event.target;
    // console.log(value)
    // Allow only numeric values
    consol.log('value', value);
    if (/^\d*$/.test(value)) {
      validation.handleChange(event); // Call the form handler if valid
    }
  };

  // const handleKeyPress = (e) => {
  //   const inputValue = e.target.value;
  //     console.log('inputValue', inputValue, typeof(inputValue));
  //     console.log('key', e.key, typeof(e.key));

  //   // Allow only numeric input and check length
  //   if ((!/[0-9]/.test(e.key) || Number(e.key) < 0 ) || ((Number(inputValue) + Number(e.key)) > 100)){
  //     e.preventDefault(); // Block non-numeric keys and prevent exceeding 100 characters
  //   }
  //   // if ((Number(inputValue) + Number(e.key)) > 100) {
  //   //   console.log('here preventDefaultpreventDefault', Number(inputValue) + Number(e.key));
  //   //   e.preventDefault();
  //   // }
  // };

  const handleKeyPress = (e) => {
    const inputValue = e.target.value; // Current input value
    const prospectiveValue = inputValue + e.key; // Simulate the new value if the key is added

    // Check if the input is numeric and within the range
    if (!/^\d$/.test(e.key)) {
      // Block non-numeric keys
      e.preventDefault();
      return;
    }

    if (Number(prospectiveValue) > 100) {
      // Prevent typing that exceeds the limit
      e.preventDefault();
      console.log(`Blocked input: ${prospectiveValue} exceeds 100`);
    }
  };

  const handleNumberChange = (e) => {
    console.log(e);
    const value = e.target.value;
    console.log('valuevalue', value);
    if (!/[0-9]/.test(Number(value))) {
      e.preventDefault(); // Block non-numeric keys and prevent exceeding 100 characters
    }
    if (Number(value) < 0 || Number(value) > 100) {
      console.log(e.form);
    } else if (value === '' || (value >= 0 && value <= 100)) {
      // onChange(e); // Only call onChange if the value is within the range or empty
    }
  };
  // const handleNumberChange
  return (
    <div className='dashboard-card'>
      <AddRecord
        form={form}
        loading={loading}
        pageTitle='Add Affiliate'
        addUserResp={addUserResp}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        switchBtn={false}
        // upload={false}
        disable={alert}
        disableButton={isdisable}
        show={show}
        // setisActive={setisActive}
        padding={true}
        handleClose={handleClose}
        submitData={submitData}
        addMessage='Are you sure you want to add Affiliate?'
        goBack={goBack}
        initialValues={{
          email: '',
          phone: '',
          address: '',
          affiliateName: '',
          contactName: '',
          isActive: true,
        }}
        inputs={[
          //   <InputField
          //     name='parentId'
          //     required={true}
          //     placeholder='Parent Id '
          //     label='Parent Id '
          //     col='col-md-4 col-12'
          //     rules={[
          //       {
          //         required: true,
          //         message: 'Enter Parent Id ',
          //       },
          //     ]}
          //   />,

          <SelectField
            // onChange={(e) => handleStatusChange(e)}
            options={affiliateParents?.map((item) => (
              <Select.Option value={item.parentId}>{item.name}</Select.Option>
            ))}
            name='parentId'
            label='Parent Id'
            col='col-md-4 col-12'
            required={true}
            disabled={alert ? true : false}
            // disabled
            rules={[
              {
                required: true,
                message: <p style={{ marginTop: '8px', color: '#FF4D4F' }}>Select Parent Id</p>,
              },
            ]}
            placeholder='Select  Parent Id'
          />,
          <InputField
            name='clientId'
            required={true}
            placeholder='Client Id '
            disabled={alert ? true : false}
            label='Client Id '
            col='col-md-4 col-12'
            rules={[
              {
                required: true,
                message: 'Enter Client Id ',
                validator: (_, value) => {
                  // Trim the value to remove spaces
                  const trimmedValue = value?.trim();

                  // Check if the trimmed value is empty
                  if (!trimmedValue) {
                    return Promise.reject('Client Id is required');
                  }

                  // If value exists, allow the validation to pass
                  return Promise.resolve();
                },
              },
            ]}
          />,
          <InputField
            name='affiliateName'
            required={true}
            placeholder='Affiliate Name'
            label='Affiliate Name'
            col='col-md-4 col-12'
            disabled={alert ? true : false}
            rules={[
              {
                required: true,
                message: 'Enter Affiliate Name',
                validator: (_, value) => {
                  // Trim the value to remove spaces
                  const trimmedValue = value?.trim();

                  // Check if the trimmed value is empty
                  if (!trimmedValue) {
                    return Promise.reject('Affiliate Name is required');
                  }

                  // If value exists, allow the validation to pass
                  return Promise.resolve();
                },
              },
            ]}
          />,

          <InputField
            name='contactName'
            required={true}
            placeholder='Contact Name'
            label='Contact Name'
            col='col-md-4 col-12'
            disabled={alert ? true : false}
            rules={[
              {
                required: true,
                message: 'Enter Contact Name',
                validator: (_, value) => {
                  // Trim the value to remove spaces
                  const trimmedValue = value?.trim();

                  // Check if the trimmed value is empty
                  if (!trimmedValue) {
                    return Promise.reject('Contact Name is required');
                  }

                  // If value exists, allow the validation to pass
                  return Promise.resolve();
                },
              },
            ]}
          />,

          <InputField
            name='email'
            required={true}
            disabled={alert ? true : false}
            label='Email'
            placeholder='Email'
            col='col-md-4 col-12'
            // onKeyPress={noPrespace}
            rules={[
              {
                required: true,
                message: 'Enter Email',
              },
              {
                type: 'email',
                message: 'Please enter a valid email address',
              },
            ]}
          />,
          <InputField
            name='address'
            required={true}
            placeholder='Address'
            label='Address'
            disabled={alert ? true : false}
            col='col-md-4 col-12'
            rules={[
              {
                required: true,
                message: 'Enter Address',
                validator: (_, value) => {
                  // Trim the value to remove spaces
                  const trimmedValue = value?.trim();

                  // Check if the trimmed value is empty
                  if (!trimmedValue) {
                    return Promise.reject('Address is required');
                  }

                  // If value exists, allow the validation to pass
                  return Promise.resolve();
                },
              },
            ]}
          />,
          <InputField
            name='callBackUrl'
            required={true}
            placeholder='Callback Url '
            label='Callback Url'
            disabled={alert ? true : false}
            col='col-md-4 col-12'
            rules={[
              {
                required: true,
                message: 'Enter Callback Url',

                validator: (_, value) => {
                  // Trim the value to remove spaces
                  const trimmedValue = value?.trim();

                  // Check if the trimmed value is empty
                  if (!trimmedValue) {
                    return Promise.reject('Callback Url is required');
                  }

                  // If value exists, allow the validation to pass
                  return Promise.resolve();
                },
              },
            ]}
          />,
        ]}
        inputMask={[
          <InputMasker
            name='phone'
            required={true}
            label='Mobile'
            placeholder='Mobile'
            disabled={alert ? true : false}
            col='col-md-4 col-12'
            rules={[
              {
                required: true,
                message: 'Enter Mobile',
              },
            ]}
            handleChange={handleChange}
          />,
        ]}
      />
      {/* {alert && (
        <div className='pb-3 -mt-7 flex justify-center'>
          <Alert message={successMsg} type='success' showIcon />
        </div>
      )} */}
      {alert && (
        <div>
          <Form name='inventoryList' onFinishFailed={shopPartnerMappingFailed} onFinish={shopPartnerMapping} className='row p-5 px-3 pb-1' autoComplete='off' initialValues={{ invList: [''] }}>
            <div
              className='row w-100 mx-0 mb-3 align-items-center'
              style={{
                backgroundColor: '#ffffff', // White background for a clean look
                padding: '15px 20px', // Increased padding for better spacing
                borderRadius: '8px', // Slightly larger rounded corners
                fontSize: '16px', // Improved readability
                border: '1px solid #e0e0e0', // Subtle border for structure
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // Light shadow for depth
              }}
            >
              <div
                className='col-3 col-sm-4  col-md-3 font-weight-semibold text-center text-md-left'
                style={{ fontSize: '16px' }} // Adjusted font size
              >
                Product
              </div>
              <div
                className='col-2 col-sm-2 col-md-2 font-weight-semibold  text-center text-md-left'
                style={{ fontSize: '16px' }} // Adjusted font size
              >
                Parent Commission
              </div>
              <div
                className='col-2 col-sm-2 col-md-2 font-weight-semibold  text-center text-md-left'
                style={{ fontSize: '16px' }} // Adjusted font size
              >
                Client Commission
              </div>
              {apiResp ? (
                <>
                  <div className='col-3 col-sm-3 col-md-3 font-weight-semibold text-center text-md-left' style={{ fontSize: '16px' }}>
                    URL
                  </div>
                  {/* <div className='col-1 col-sm-1 col-md-2 font-weight-semibold  text-center text-md-left' style={{ fontSize: '16px' }}>
                    Action
                  </div> */}
                </>
              ) : (
                <div className='col-4 col-sm-4 col-md-5 font-weight-semibold  text-left text-black ps-4 ' style={{ fontSize: '16px' }}>
                  Action
                </div>
              )}
            </div>

            <Form.List name='invList'>
              {(fields, { add, remove }) => (
                <>
                  {console.log('fields', fields)}
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Space key={key} className='col-md-12 m-0 ' align='baseline' gap='13'>
                      <div className='row w-100 mx-0'>
                        {/* Select Product */}
                        <Form.Item
                          {...restField}
                          name={[name, 'product']}
                          className='col-4 px-0 col-sm-4 col-md-3'
                          rules={[
                            {
                              required: true,
                              message: 'Select a Product',
                            },
                          ]}
                        >
                          {/* <label htmlFor=''>Product Selection</label> */}
                          <Select placeholder='Select Product' style={{ marginBottom: '5px' }} disabled={apiResp} onChange={(value) => handleProductChange(value, index)}>
                            {getFilteredProducts(index).map((item) => (
                              <Select.Option key={item.productId} value={item.productId}>
                                {item.name}
                              </Select.Option>
                            ))}
                            {/* {products.map((item) => (
                            <Select.Option key={item.productId} value={item.productId}>
                              {item.name}
                            </Select.Option>
                          ))} */}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'commission']}
                          className='col-2 px-0 col-sm-2 col-md-2 mx-1'
                          rules={[
                            {
                              required: true,
                              message: (
                                <p className=' nowrap' style={{ marginTop: '-30px', color: '#FF4D4F' }}>
                                  Enter Commission{' '}
                                </p>
                              ),
                            },
                            // {
                            //   validator: (_, value) => {
                            //     if (value === undefined || value === null || value === '') {
                            //       return Promise.reject('Enter Commission');
                            //     }
                            //     if (value < 0 || value > 100) {
                            //       return Promise.reject('Commission must be between 0 and 100');
                            //     }
                            //     return Promise.resolve();
                            //   },
                            // },
                          ]}
                        >
                          <InputField
                            name='commission'
                            placeholder='Enter Parent Commission'
                            // label='Commission (%)'
                            min='0'
                            max='100'
                            type='text'
                            // onChange={(e)=>handleNumberChange(e)}
                            onKeyPress={(e) => handleKeyPress(e)}
                            className='col-12 px-0 col-sm-7 col-md-3'
                          />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'clientcommission']}
                          className='col-2 px-0 col-sm-2 col-md-2 mx-1'
                          rules={[
                            {
                              required: true,
                              message: (
                                <p className=' nowrap' style={{ marginTop: '-30px', color: '#FF4D4F' }}>
                                  Enter Commission{' '}
                                </p>
                              ),
                            },
                            // {
                            //   validator: (_, value) => {
                            //     if (value === undefined || value === null || value === '') {
                            //       return Promise.reject('Enter Commission');
                            //     }
                            //     if (value < 0 || value > 100) {
                            //       return Promise.reject('Commission must be between 0 and 100');
                            //     }
                            //     return Promise.resolve();
                            //   },
                            // },
                          ]}
                        >
                          <InputField
                            name='clientcommission'
                            placeholder='Enter Client  Commission'
                            // label='Commission (%)'
                            min='0'
                            max='100'
                            type='text'
                            // onChange={(e)=>handleNumberChange(e)}
                            onKeyPress={(e) => handleKeyPress(e)}
                            className='col-12 px-0 col-sm-7 col-md-3'
                          />
                        </Form.Item>

                        {!apiResp && (
                          <div
                            className='col-1 col-sm-1 col-md-2 ms-1'
                            // disabled={apiResp}
                            style={{
                              fontSize: '1rem',
                              color: 'red',
                              paddingTop: '0.5rem',
                            }}
                          >
                            <MinusCircleOutlined
                              onClick={() => {
                                if (fields.length > 1) {
                                  handleRemove(name, remove, index); // Call the updated remove function
                                }
                              }}
                            />
                            {/* <MinusCircleOutlined
                            onClick={() => {
                              if (fields.length > 1) {
                                remove(name);
                              }
                            }}
                          /> */}
                          </div>
                        )}
                        {/* Display URL */}
                        {apiResp && apiUrl[index] && (
                          <>
                            <div
                              // className='col-12 col-md-6 px-0 px-md-2'

                              className='col-2 px-0  col-md-3 mx-4'
                              style={
                                {
                                  // border: '1px solid red',
                                }
                              }
                            >
                              {/* <div className='flex gap-2 gap-md-5 items-center flex-wrap flex-md-nowrap pb-3'> */}
                              {/* Display the first 50 characters of the URL */}
                              <div className='text-slate-500 w-75 flex-wrap'>
                                <Tooltip title={apiUrl[index].url} className=''>
                                  {apiUrl[index].url.slice(0, 30)}...
                                </Tooltip>
                              </div>

                              {/* Copy to Clipboard Button */}

                              {/* </div> */}
                            </div>
                            <div
                              // className='col-12 col-md-6 px-0 px-md-2'

                              className='col-2 px-0  col-md-1 mx-1 '
                              style={
                                {
                                  // border: '1px solid red',
                                }
                              }
                            >
                              <button
                                onClick={(e) => {
                                  e.preventDefault(); // Prevent form submission
                                  navigator.clipboard.writeText(apiUrl[index].url);
                                  message.success('URL copied to clipboard!');
                                }}
                                className=' col-12 btn btn-primary mb-2 mb-sm-0 '
                              >
                                Copy URL
                              </button>
                            </div>
                          </>
                          // <>
                          //   <div className='col-12 col-sm-2 col-md-3  text-slate-500 w-75 border '>{apiUrl[index].url}</div>
                          //   <div className=' col-12 col-sm-1 col-md-3   text-slate-500 w-75'>
                          //     {/* Copy to Clipboard Button */}
                          //     <button
                          //       onClick={(e) => {
                          //         e.preventDefault(); // Prevent form submission
                          //         navigator.clipboard.writeText(apiUrl[index].url);
                          //         message.success('URL copied to clipboard!');
                          //       }}
                          //       className='btn btn-primary  mb-2 mb-sm-0 '
                          //     ></button>
                          //   </div>
                          // </>
                        )}
                        {/* <div className='row'> */}

                        {/* </div> */}
                      </div>
                    </Space>
                  ))}
                  {!apiResp && (
                    // <button
                    //   disabled={apiResp}
                    //   onClick={() => {
                    //     add();
                    //     // handleNewProductAdd();
                    //     setNoinvList(false);
                    //   }}
                    //   type='primary'
                    //   className={`btn btn-primary button col-10 col-sm-2 col-md-1 mx-sm-2 ${noinvList ? 'mb-1' : 'mb-4'}`}
                    //   style={{
                    //     marginTop: '1rem',
                    //   }}
                    // >
                    //   Add
                    // </button>
                    <div
                      // className='col-2 col-sm-1 col-md-2 mx-sm-2  '
                      //
                      // style={{}}
                      style={{
                        // border: '1px solid red',
                        marginTop: '1.8px',
                        marginLeft: '4px',
                      }}
                    >
                      <button
                        disabled={apiResp}
                        onClick={() => {
                          add();
                          // handleNewProductAdd();
                          setNoinvList(false);
                        }}
                        type='primary'
                        // className={` border btn btn-primary button col-12 col-sm-6 col-md-3  mx-sm-2  ${noinvList ? 'mb-1' : 'mb-4'}`}
                        // className={` border btn btn-primary button col-md-12 ${noinvList ? 'mb-1' : 'mb-4'}`}
                        className={`btn btn-primary button px-6  ${noinvList ? 'mb-1' : 'mb-4'}`}
                        style={{
                          marginBottom: '1rem',
                        }}
                      >
                        Add
                      </button>
                    </div>
                  )}
                </>
              )}
            </Form.List>

            <div>
              <button disabled={apiResp} type='primary' class='btn btn-primary button col-md-2 mb-2' htmlType='submit'>
                Submit
              </button>
            </div>
          </Form>
        </div>
      )}
    </div>
    // </div>
  );
};

export default AddShopPartner;
